import { Image } from '@headless-workspace/typings';
import { ObjectHelpers } from '@headless-workspace/utils';
import { ProductDetailBannerType } from '../ProductDetailBannerType';
import { ProductDetailBannerValue } from '../ProductDetailBannerValue';
import { type PromoBannerDTO } from './PromoBannerDTO';

export type PromoBannerValue = {
    type: ProductDetailBannerType;
    title: string;
    description?: string;
    content: string;
    image: Image;
    id: string;
    legalMention?: string;
    href?: string;
};

const DEFAULT_GWP_IMG = '/images/genericPromoBanner.png';

export const isPromoBanner = (banner: ProductDetailBannerValue): banner is PromoBannerValue => {
    return ProductDetailBannerType.GiftWithPurchase === banner.type || ProductDetailBannerType.Fidelity === banner.type;
};

const promoBannerTypes = {
    gwp: ProductDetailBannerType.GiftWithPurchase,
    fidelity: ProductDetailBannerType.Fidelity,
};

export const mapPromoBanner = (dto: PromoBannerDTO): PromoBannerValue => {
    const imageSrc = dto.image?.default ?? DEFAULT_GWP_IMG;
    const imageAlt = dto.image?.alt;

    return {
        type: promoBannerTypes[dto.type],
        id: dto.id,
        title: dto.title ?? '',
        description: dto.description ?? '',
        content: dto.legalMention ?? '',
        image: ObjectHelpers.createImageWithSrc(imageSrc, imageAlt),
        href: dto?.cta?.link,
    };
};
